import axios from "axios";

const baseURL = window._env_.REACT_APP_ENDPOINT_PRODUCTOS  || 'https://prevision.sam.corp/o/buscador'

const axiosInstance = axios.create({
	baseURL: baseURL,
	// baseURL: 'https://prevision.sam.pre.corp/o/buscador',
	// baseURL: 'http://demo0048497.mockable.io/o/buscador',
	// baseURL: 'http://demo3064906.mockable.io/o/buscador',
	// baseURL: ' http://demo5709831.mockable.io/o/buscador'
	// baseURL: 'http://demo4911473.mockable.io/epsvProduct'
	// baseURL: 'http://localhost:3002'
});

export default axiosInstance;
